<template>
  <div class="ts-border ts-p-3 ts-rounded">
    <div class="ts-overflow-y-scroll" style="max-height: 50vh">
      <table class="ts-w-full">
        <thead>
          <tr>
            <th class="ts-text-center" style="width: 1%">
              {{ $t('no') }}
            </th>
            <th style="width: 7%">
              {{ $t('tradeIn.barcode') }}
            </th>
            <th style="width: 8%">
              {{ $t('tradeIn.group') }}
            </th>
            <th style="width: 200px">
              {{ $t('tradeIn.productName') }}
            </th>
            <th class="ts-text-center" style="width: 6%">
              {{ $t('tradeIn.uom') }}
            </th>
            <th class="ts-text-center" style="width: 10%">
              {{ $t('tradeIn.cost') }}
            </th>
            <th class="ts-text-center" style="width: 8%">
              {{ $t('tradeIn.qty') }}
            </th>
            <th class="ts-text-center" style="width: 10%">
              {{ $t('tradeIn.amount') }}
            </th>
            <th class="ts-text-center" style="width: 10%">
              {{ $t('tradeIn.convertedAmount') }}
            </th>
            <th class="ts-text-center" style="width: 3%">
              <a
                v-if="model.ref_stock_out_id"
                href="#"
                class="ts-text-white"
                @click.prevent="addNewRow"
              >
                <i class="fa fa-plus"></i>
              </a>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="model.product_details == 0">
            <td colspan="13" class="ts-text-center ts-p-3 ts-space-x-1">
              <i class="fa fa-folder-open ts-text-gray-200"></i>
              <label class="ts-text-gray-400">
                {{ $t('noData') }}
              </label>
              <div
                class="validate ts-text-left"
                v-if="errors.has('product_details')"
              >
                {{ errors.first('product_details') }}
              </div>
            </td>
          </tr>
          <tr v-for="(detail, index) in model.product_details" :key="index">
            <td class="ts-text-center">
              {{ index + 1 }}
            </td>
            <td valign="top" class="ts-w-32">
              <input
                type="text"
                class="form-control"
                style="min-width: 50px;"
                :value="detail.barcode"
                readonly
              />
            </td>
            <td valign="top" class="ts-w-32">
              <input
                type="text"
                class="form-control"
                style="min-width: 50px;"
                :value="detail.pro_group_name_en"
                readonly
              />
            </td>
            <td valign="top">
              <input
                type="text"
                :value="detail.product_name_en"
                class="form-control"
                readonly
                style="min-width: 200px;border-bottom-right-radius: 0px !important;border-top-right-radius: 0px !important"
              />
            </td>
            <td valign="top" class="ts-w-32">
              <input
                type="text"
                class="form-control"
                style="min-width: 50px;"
                :value="detail.uom_name_en"
                readonly
              />
            </td>
            <td valign="top">
              <ts-currency-converter-input
                :input_amount.sync="detail.input_cost"
                :amount.sync="detail.cost"
                :input_currency_id.sync="detail.input_currency_id"
                :currency_id.sync="detail.currency_id"
                :fx_rate.sync="detail.fx_rate"
                :fx_rate_ratio.sync="detail.fx_rate_ratio"
                style="min-width: 120px;"
                :class="{
                  'is-invalid': errors.has(
                    'product_details.' + index + '.cost'
                  )
                }"
              />
              <div
                class="invalid-feedback"
                v-if="errors.has('product_details.' + index + '.cost')"
              >
                {{ errors.first('product_details.' + index + '.cost') }}
              </div>
            </td>
            <td valign="top">
              <input
                v-model.number="detail.quantity"
                disabled
                type="number"
                ref="quantity"
                class="form-control ts-text-center"
                :class="{
                  'is-invalid': errors.has(
                    'product_details.' + index + '.quantity'
                  )
                }"
                style="min-width: 80px"
              />
              <div
                class="invalid-feedback"
                v-if="errors.has('product_details.' + index + '.quantity')"
              >
                {{ errors.first('product_details.' + index + '.quantity') }}
              </div>
            </td>
            <td valign="top">
              <ts-currency-input
                v-model.number="detail.input_total_amount"
                class="form-control ts-text-right"
                style="min-width: 120px"
                :currency="getCurrencySign(detail.input_currency_id)"
                :precision="getPrecision(detail.input_currency_id)"
                :disabled="true"
              />
            </td>
            <td valign="top">
              <ts-currency-input
                v-model.number="detail.total_amount"
                class="form-control ts-text-right"
                style="min-width: 120px"
                :currency="getCurrencySign(detail.currency_id)"
                :precision="getPrecision(detail.currency_id)"
                :disabled="true"
              />
            </td>
            <td class="ts-text-center">
              <div class="ts-space-x-2 ts-flex">
                <a
                  href="#"
                  v-if="detail.is_generate_unique_serial"
                  @click.prevent="viewSerialProduct(detail)"
                >
                  <i class="fas fa-list"></i>
                </a>
                <a
                  href="#"
                  class="ts-text-red-600 ts-my-auto"
                  @click.prevent="removeRow(detail)"
                >
                  <i class="fa fa-trash"></i>
                </a>
              </div>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="total-footer">
            <td colspan="2">
              <b>
                {{ $t('tradeIn.numberRow') }} :
                {{ model.product_details.length }}
              </b>
            </td>
            <td colspan="4" class="ts-text-right">
              <b>{{ $t('tradeIn.total') }} :</b>
            </td>
            <td>
              <input
                v-model.number="sumTotalQty"
                type="number"
                class="form-control ts-text-center"
                style="min-width: 100px;border:transparent;"
                readonly
              />
            </td>
            <td class="ts-text-right">
              <b>{{ $t('tradeIn.total') }} :</b>
            </td>
            <td>
              <ts-currency-input
                v-model.number="total"
                class="form-control ts-text-right ts-font-bold"
                style="min-width: 100px;border:transparent;"
                :currency="defaultCurrency.currency_symbol"
                :precision="defaultCurrency.currency_rounding"
                :disabled="true"
              />
            </td>
            <td></td>
          </tr>
        </tfoot>
      </table>
      <!-- modal show pop-up to be able add product -->
      <a-modal
        v-if="show_modal_add_product"
        v-model="show_modal_add_product"
        :footer="null"
        :zIndex="1020"
        :maskClosable="false"
        width="800px"
        :title="$t('tradeIn.product')"
      >
        <ProductList
          v-model="model"
          :loading="loading"
          @close="show_modal_add_product = false"
        />
      </a-modal>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import ProductList from './product-list.vue'
import DisplaySerialsProduct from './display-serial-product.vue'

export default {
  name: 'itemList',
  components: {
    ProductList
  },
  props: ['value', 'validate'],
  data() {
    return {
      errors: new Errors(),
      model: {},
      show_modal_add_product: false,
      loading: false
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    ...mapState('stock/tradeIn', [
      'edit_data',
      'formViewDatas',
      'invoice_products'
    ]),
    defaultCurrency() {
      if (this.formViewDatas['currency']) {
        return this.formViewDatas['currency'].find(el => el.is_default == true)
      }
      return {
        currency_symbol: '',
        currency_rounding: null
      }
    },
    total() {
      return _.sumBy(this.model.product_details, function(o) {
        return o.total_amount
      })
    },
    grandTotal() {
      return _.sumBy(this.model.product_details, function(o) {
        return o.grand_total
      })
    },
    sumTotalQty() {
      return _.sumBy(this.model.product_details, 'quantity')
    }
  },
  methods: {
    ...mapActions('stock/tradeIn', ['getFormViewModel']),
    viewSerialProduct(item) {
      this.$modal.show(
        DisplaySerialsProduct,
        {
          data: item,
          value: this.model
        },
        {
          height: 'auto',
          width: '550px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: true
        }
      )
    },
    findProduct(product_id) {
      return this.invoice_products.find(el => el.product_id == product_id)
    },
    getCurrencySign(currency_id) {
      if (this.formViewDatas['currency']) {
        const currency = this.formViewDatas['currency'].find(
          el => el.currency_id == currency_id
        )
        return currency ? currency.currency_symbol : null
      }
      return null
    },
    getPrecision(currency_id) {
      if (this.formViewDatas['currency']) {
        const currency = this.formViewDatas['currency'].find(
          el => el.currency_id == currency_id
        )
        return currency ? currency.currency_rounding : null
      }
      return null
    },
    addNewRow() {
      this.show_modal_add_product = true
    },
    removeRow(row) {
      this.model.product_details.splice(
        this.model.product_details.indexOf(row),
        1
      )
    },
    calculate() {
      this.model.product_details.forEach(el => {
        const calculateWithFxRate = value => value * el.fx_rate_ratio
        el.input_total_amount = el.input_cost * el.quantity
        el.total_amount = calculateWithFxRate(el.input_total_amount)
      })
      this.model.invoice_amount = _.sumBy(this.model.product_details, function(
        el
      ) {
        return el.total_amount
      })
    }
  },
  watch: {
    'model.product_details': {
      handler() {
        this.calculate()
      },
      deep: true
    },
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>

<style scoped>
.form-control[disabled],
.form-control[readonly],
fieldset[disabled] .form-control {
  opacity: 1;
}

.py {
  padding: 0.45rem 0;
}

.max-h {
  min-height: 30vh;
  max-height: 50vh;
}

table {
  position: relative;
  border-collapse: collapse;
}

table thead tr th {
  padding: 4px 5px;
  z-index: 3;
  position: sticky;
  top: 0;
  /* Don't forget this, required for the stickiness */
  background-color: rgb(22, 102, 145);
  color: white;
  text-transform: uppercase;
  border-width: 1px;
  white-space: nowrap;
}

table tbody tr td {
  padding: 4px 5px;
  border-width: 1px;
}

table tfoot tr {
  background-color: #e3e8f1;
  border-width: 1px;
}

table tfoot tr td {
  padding: 0 5px;
  white-space: nowrap;
  border: 1px solid white;
}

.total-footer .form-control {
  font-weight: 900;
}
</style>
